import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { useAppStore } from "@/stores";
import { getGrowthBook } from "@/growthbook";
function useGrowthbook() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getGrowthBook();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const growthbook = t0;
  const {
    updateGeneralAppState
  } = useAppStore();
  let t1;
  let t2;
  if ($[1] !== updateGeneralAppState) {
    t1 = () => {
      if (process.env.NEXT_PUBLIC_API_MOCKING !== "enabled") {
        growthbook.init().then(() => {
          updateGeneralAppState({
            isGrowthbookLoaded: true
          });
        });
      } else {
        updateGeneralAppState({
          isGrowthbookLoaded: true
        });
      }
    };
    t2 = [growthbook, updateGeneralAppState];
    $[1] = updateGeneralAppState;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  React.useEffect(t1, t2);
}
export default useGrowthbook;